const getGenres = () => {};

export default getGenres;
